import React from "react";
import { useParams } from "react-router-dom";
import { EvtHeader } from "components/header";
import EditItemButton from "components/buttons/edit";
import { EvtStatsCard } from "components/stats/display-card";
import { Badge } from "ui/components/badge";
import { DropdownMenuItem } from "ui/components/dropdown-menu";
import { PermissionControlledInput } from "permissions/components/input";
import { EvtEmployeeCard } from "components/employee/display-card";
import { useFetch } from "@/hooks/useFetch";
import { STATUSES } from "@/components/status/constant";
import HeaderPortal from "components/portal/header-portal";
import TiptapEditor from "components/tiptap-editor";
import { fetchOpeningMeta } from "../api";
import ExpertiseDisplay from "./expertise-display";


export default function OpeningDetails() {
    const { openingId } = useParams();

    const { data: opening, isLoading, isError } = useFetch({
        queryKey: [openingId],
        queryFn: () => fetchOpeningMeta({ openingId }),
    });

    const status = STATUSES[opening?.status];

    if (isLoading) return <div className="p-8">Loading...</div>;

    if (isError) return (
        <div className="p-8 text-red-500">Error loading opening details.</div>
    );

    if (!opening) return <div className="p-8">No opening found.</div>;

    return (
        <div className="flex-1 flex flex-col gap-2">
            <EvtHeader title="Dashboard" />

            <section>
                <div className="grid grid-cols-3 px-4 gap-4 md:px-6 mt-2.5 min-h-24">
                    {/* Status */}
                    <EvtStatsCard
                        label="Status"
                        value={<div className="flex"><Badge className={status?.className}>{status?.label}</Badge></div>}
                    />
                    {/* Skill */}
                    <EvtStatsCard
                        label="Skills"
                        value={<p className="text-base">{opening?.skills?.map(s => s.skill?.name).join(', ')}</p>}
                    />
                    {/* Expertise */}
                    <EvtStatsCard
                        label="Expertise"
                        value={<p className="text-base"><ExpertiseDisplay value={opening?.expertise} /></p>}
                    />
                </div>
            </section>

            <section>
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 px-4 gap-4 md:px-6 mt-2.5">
                    <div className="flex flex-col gap-2">
                        <div className="text-gray-600">Sales Coordinator</div>
                        <EvtEmployeeCard user={opening?.sales_coordinator} />
                    </div>
                   
                </div>
            </section>
    <section>
                <div className="px-6 mt-2">
                <div className="flex flex-col gap-2">
                        <div className="text-gray-600">Opportunity Link</div>
                        {opening?.opportunity_link ? (
                            <a
                                href={opening.opportunity_link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-sm hover:underline"
                            >
                                {opening.opportunity_link}
                            </a>
                        ) : (
                            <span className="text-sm text-gray-500">-</span>
                        )}
                    </div>
</div>
</section>
                    

            <section>
                <div className="px-6 mt-2">
                    {opening?.description && <div>
                        <div className="text-gray-600 mb-2">Description</div>
                        <div className="font-normal text-sm leading-relaxed text-gray-700 bg-gray-50/50 p-4 rounded-lg border border-gray-200/60 whitespace-pre-wrap">
                            {opening?.description ? (
                                <TiptapEditor value={opening?.description} readOnly={true} />
                            ) : (
                                <p className="text-sm text-zinc-500">No description provided</p>
                            )}
                        </div>
                    </div>}
                </div>
            </section>

         
            <HeaderPortal>
                <PermissionControlledInput
                    rule="update:*"
                    collection="openings"
                >
                    <EditItemButton variant="ghost" />
                </PermissionControlledInput>
            </HeaderPortal>
        </div>
    );
}
